import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRef, computed } from 'vue';
import { ElInput } from 'element-plus';
import IconCopy from '@/components/icons/Copy.vue';
import InputAction from './InputAction.vue';

interface Props {
  type?: string,
  value: string,
  maxlength?: number,
  disabled?: boolean,
  error?: any,
  showCounter?: boolean,
  placeholder?: string,
  copy?: boolean,
  accept?: string,
  autosize?: boolean | {minRows: number, maxRows: number},
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UiInput',
  props: {
    type: { default: 'text' },
    value: { default: '' },
    maxlength: { default: Infinity },
    disabled: { type: Boolean, default: false },
    error: { default: null },
    showCounter: { type: Boolean, default: false },
    placeholder: { default: '' },
    copy: { type: Boolean, default: false },
    accept: { default: '' },
    autosize: { type: [Boolean, Object], default: false }
  },
  emits: ["input", "keydown", "focus", "blur"],
  setup(__props: any) {

const props = __props;



const modelValue = toRef(props, 'value');

const classInput = computed(() => ({
  'is-counter-max': props.maxlength === modelValue.value.length,
  'is-error': props.error,
  'is-copy': props.copy,
}
));

const copyToClipboard = () => {
  navigator.clipboard.writeText(props.value);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElInput), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    maxlength: _ctx.maxlength,
    disabled: _ctx.disabled,
    showWordLimit: _ctx.showCounter,
    type: _ctx.type,
    accept: _ctx.accept,
    placeholder: _ctx.placeholder,
    autosize: _ctx.autosize,
    class: _normalizeClass([classInput.value, "main-input"]),
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', $event))),
    onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('keydown', $event))),
    onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('focus', $event))),
    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('blur', $event)))
  }, _createSlots({ _: 2 }, [
    (_ctx.copy)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(InputAction, {
              class: "main-input__copy_icon",
              disabled: !_ctx.value,
              onClick: copyToClipboard
            }, {
              default: _withCtx(() => [
                _createVNode(IconCopy)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "maxlength", "disabled", "showWordLimit", "type", "accept", "placeholder", "autosize", "class"]))
}
}

})